import {
  EDITOR_DELETE_PAGE_BEGIN,
  EDITOR_DELETE_PAGE_SUCCESS,
  EDITOR_DELETE_PAGE_FAILURE,
  EDITOR_DELETE_PAGE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../home/app_util';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deletePage(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EDITOR_DELETE_PAGE_BEGIN,
    });
    const { projectId, version, pageId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const config = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${pageId}`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_DELETE_PAGE_SUCCESS,
            data: pageId,
          });
          Mixpanel.track('Deleted page on builder', { uuid: pageId });
          toast.success('Deleted Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_DELETE_PAGE_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete page on builder');
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Deletion Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeletePageError() {
  return {
    type: EDITOR_DELETE_PAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_DELETE_PAGE_BEGIN:
      return {
        ...state,
        deletePagePending: true,
        deletePageError: null,
      };

    case EDITOR_DELETE_PAGE_SUCCESS:
      return {
        ...state,
        deletePagePending: false,
        deletePageError: null,
        pages: state.pages.filter((e) => e.uuid !== action.data),
      };

    case EDITOR_DELETE_PAGE_FAILURE:
      return {
        ...state,
        deletePagePending: false,
        deletePageError: action.data.error,
      };

    case EDITOR_DELETE_PAGE_DISMISS_ERROR:
      return {
        ...state,
        deletePageError: null,
      };

    default:
      return state;
  }
}
